(function() {
    'use strict';

    const TR = angular.module('TR');
    TR.directive('hideMenuBar', function($location, $window) {

        return {
            restrict: 'A',
            scope: '=',
            compile($elem) {
                if (window.TRPCONFIG.Domain2.ShowMinimalHeader) { return; }
                const elem = $elem[0];

                const isMatchedPath = () => {
                    const regEx = /.*\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}[0-9a-fA-F]{0,1}[/]*?/;
                    let abtesttUrl = ($location.$$path.match(regEx) || $location.$$path.match(/attractions[/].*/));
                    const abtesttUrlMatched = abtesttUrl && abtesttUrl.input;
                    return abtesttUrlMatched;
                };

                if (isMatchedPath()) {
                    elem.classList.add('u-hidden');
                } else {
                    elem.classList.remove('u-hidden');
                }

                return function postLink($scope, $el) {
                    const el = $el[0];
                    const hideMenu = () => {
                        const elClassList = el.classList;
                        const menuBarEl = elClassList.contains('sc-c-menubar');
                        const headerEl = el.closest('.sc-c-masthead');
                        const headerNextElementSiblingEl = headerEl && headerEl.nextElementSibling;
                        const mastHeadMainEl = headerEl && headerEl.querySelector('.sc-c-masthead__main');
                        const hasShadowClass = mastHeadMainEl && mastHeadMainEl.classList.contains('sc-c-masthead__main--box-shadow');
                        const hasHiddenMenuClass = headerNextElementSiblingEl && headerNextElementSiblingEl.classList.contains('sc-c-main--hidden');
                        const hasHiddenClass = elClassList.contains('u-hidden');
                        const mastHeadMainElClassList = mastHeadMainEl.classList;
                        const headerNextElementSiblingElClassList = headerNextElementSiblingEl.classList;
                        const mastHeadCss = 'sc-c-masthead__main--box-shadow';
                        const menuBarCss = 'sc-c-main--hidden';

                        if (isMatchedPath()) {
                            if (!hasShadowClass) {
                                mastHeadMainElClassList.add(mastHeadCss);
                            }

                            if (!hasHiddenMenuClass) {
                                headerNextElementSiblingElClassList.add(menuBarCss);
                            }

                            if (menuBarEl && !hasHiddenClass) {
                                elClassList.add('u-hidden');
                            }
                        } else {
                            if (hasShadowClass) {
                                mastHeadMainElClassList.remove(mastHeadCss);
                            }

                            if (hasHiddenMenuClass) {
                                headerNextElementSiblingElClassList.remove(menuBarCss);
                            }

                            if (menuBarEl && hasHiddenClass) {
                                elClassList.remove('u-hidden');
                            }
                        }

                    };

                    const initHideMenu = () => {
                        if (window.TRPCONFIG.Domain2.HideMinimalHeader) {
                            hideMenu();
                        }
                    };

                    $scope.$on('$routeChangeStart', () => {
                        initHideMenu();
                    });

                    $scope.$on('$routeChangeSuccess', () => {
                        initHideMenu();
                    });

                    $window.onload = () => {
                        initHideMenu();
                    };

                    /*eslint-disable */
                    window._vwo_evq = window._vwo_evq || [];
                    window._vwo_evq.push = function(...args) {
                    /*eslint-enable */
                        const eventData = args[0];
                        if (eventData[1] === '303') {
                            initHideMenu();
                        }
                    };
                };
            }
        };
    });
    })();
